import { render } from "./RegionsTable.vue?vue&type=template&id=08e48e5b&ts=true"
import script from "./RegionsTable.vue?vue&type=script&lang=ts"
export * from "./RegionsTable.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/mitliv/wp-content/themes/wp-mitliv-theme/resources/views/backend/statistics/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__